import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo7/usoderechos.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo7 } from "../../../routes/Module7";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo7/Actividad 1.mp3";

const Actividad1 = () => {
  const infoUnidad = modulo7.content[0];
  const infoAct = modulo7.content[0].activities[0];
  const crumbs = [
    {
      title: modulo7.title,
      url: "/" + modulo7.url,
    },
    {
      title:
        modulo7.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo7.content[0].activities[1].name}`,
    linkNext: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[1].path}`,
    titlePrev: modulo7.title,
    linkPrev: modulo7.url,
  };
  const metadata = {
    color: modulo7.color,
    title: `${modulo7.title} - ${infoAct.name}`,
    name: modulo7.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-md-8">
          <p>
            <small className={`c-${modulo7.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

          <ul>
            <li>Observa la escena.</li>
            <li>
              Todos los personajes están haciendo uso de algún derecho. ¿Cuáles
              son estos derechos?
            </li>
          </ul>
        </div>
      </div>
      <div className="col-md-12 col-12">
        <img src={Imagen1} alt="Inicio" className="img-fluid" />
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y ayude a identificar los
          derechos: a la educación (y a educación en tu idioma), al trabajo, a
          viajar por el territorio nacional y al extranjero, a decidir dónde
          vivir. Recalque que no son todos nuestros derechos, solo algunos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
